import { CourseState } from '../store';

export type CoursePayload = Pick<
  CourseState,
  | 'selectedLanguage'
  | 'selectedSchoolLocation'
  | 'selectedCourse'
  | 'selectedDuration'
  | 'selectedAyaDuration'
  | 'selectedStartDate'
  | 'selectedEndDate'
  | 'tripDates'
  | 'selectedClassTime'
  | 'selectedTimezone'
>;
